import { render, staticRenderFns } from "./Fire.vue?vue&type=template&id=60f31e6c"
import script from "./Fire.vue?vue&type=script&lang=js"
export * from "./Fire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports